import { SuperAdminService } from "services/superAdminService";

class ZikrsService extends SuperAdminService<any> {
  constructor() {
    super("zikrs");
  }
}
export default new ZikrsService();
